<template>
  <div class="container container-row container-v2">
    <wrap-container
      class="relative-container cascade w50 consult-right column-1 mobile"
    >
      <img
        class="img-consulta"
        src="@/assets/img/ofertaNomina/banner-page-visit-mobile.png"
        alt="Imagen mobile"
      />
    </wrap-container>
    <wrap-container
      class="relative-container cascade w50 consult-left column-1"
    >
      <wrap-container>
        <h1
          id="titulo"
          class="titulo p32 medium oscuro"
          v-safe-html="
            'Completá el formulario y empezá a cobrar tu sueldo en BBVA'
          "
        />
        <h2
          id="subtitulo"
          class="titulo oscuro"
          v-safe-html="
            'Te pedimos tus datos tal como figuran en tu documento para que podamos armar una propuesta ideal para vos.'
          "
        />
      </wrap-container>
      <form-validator>
        <!-- DNI SEXO -->
        <wrap-container
          class="grid-container grid-container--6-6 flex-col-1 custom-container"
        >
          <dni-input
            class="col1 dni-date"
            label="Número de documento"
            hint="Ej: 28956372"
            v-model="model.numeroDoc"
            :required="true"
            maxlength="8"
            @click="trackClick('dni')"
            @onFocus="trackClick('dni')"
            inputName="numeroDoc"
            :tipoDoc.sync="model.tipoDoc"
            analyticsName="número de documento"
            quantumObfuscate
          />
          <sexo-select
            class="col2"
            name="sexo"
            :required="true"
            v-model="model.sexo"
            @click="trackClick('sexo')"
            quantumObfuscate
          />
        </wrap-container>
        <!-- NOMBRE -->
        <wrap-container
          class="grid-container grid-container--6-6 flex-col-1 custom-container"
        >
          <text-input
            class="col1"
            label="Nombres"
            hint="Ingresá tus nombres"
            name="nombre"
            v-model="model.nombre"
            :maxlengthError="20"
            :required="true"
            pattern="(^[A-Za-z ']{1,20})$"
            @click="trackClick('nombre')"
            @onFocus="trackClick('nombre')"
            analyticsName="nombre"
            :analyticsTypology="config.analyticsTypology"
            quantumObfuscate
          />
          <text-input
            class="col2"
            label="Apellidos"
            hint="Ingresá tus apellidos"
            name="apellido"
            v-model="model.apellido"
            :maxlengthError="55"
            :required="true"
            pattern="(^[A-Za-z ']{1,55})$"
            @click="trackClick('apellido')"
            @onFocus="trackClick('apellido')"
            analyticsName="apellido"
            :analyticsTypology="config.analyticsTypology"
            quantumObfuscate
          />
        </wrap-container>
        <wrap-container v-show="model.tipoDoc === tiposDocumentos.DNE">
          <section-label value="Indicanos tu tipo de residencia:" />
          <residence-type
            v-model="model.tipoResidencia"
            name="tipoResidencia"
            :required="model.tipoDoc === tiposDocumentos.DNE"
            quantumObfuscate
          />
        </wrap-container>
        <wrap-container
          class="double-width grid-container--6-6"
          v-show="model.tipoDoc === tiposDocumentos.DNE"
        >
          <country-selector
            :esExtranjero="model.tipoDoc === tiposDocumentos.DNE"
            class="col1"
            v-model="model.nacionalidad"
            name="nacionalidad"
            @click="trackClick('nacionalidad')"
            @onFocus="trackClick('nacionalidad')"
            quantumObfuscate
          />
        </wrap-container>
        <!-- Mail date -->
        <wrap-container>
          <wrap-container
            class="grid-container grid-container--6-6 flex-col-1 custom-container"
          >
            <email-field
              class="col1 email-date"
              v-model="model.email"
              name="email"
              :required="true"
              @click="trackClick('email')"
              @onFocus="trackClick('email')"
              analyticsName="email"
              :analyticsTypology="config.analyticsTypology"
              quantumObfuscate
            />
            <date-field
              class="col2 email-date"
              v-model="model.fechaNacimiento"
              name="fechaNacimiento"
              :required="true"
              :minAge="14"
              :maxAge="100"
              @click="trackClick('fechaNacimiento')"
              @onFocus="trackClick('fechaNacimiento')"
              :compatible="validarNumeroDocFechaNacimiento"
              :debeSerMayor="true"
              analyticsName="fecha de nacimiento"
              quantumObfuscate
            />
          </wrap-container>
        </wrap-container>
        <!-- Telefono -->
        <wrap-container>
          <!-- <section-label value="Celular" /> -->
          <phone-number
            class="flex-col-1"
            v-model="model.celular"
            :required="true"
            name="celular"
            quantumObfuscate
          />
        </wrap-container>
        <wrap-container>
          <div class="terms-wrapper container">
            <p>
              Al continuar acepto los
              <custom-link
                class="custom-link"
                label="Términos y Condiciones"
                analyticsName="terminos y condiciones"
                @click.native="showTerms()"
              />
              sobre el tratamiento de datos.
            </p>
          </div>
        </wrap-container>
        <wrap-container v-if="!isProduction"></wrap-container>
        <sales-button
          ref="salesbutton"
          id="conocerOferta"
          @click="probar"
          label="Continuar"
          analyticsName="conocer oferta"
          color="#1464A5"
        />
        <wrap-container>
          <div class="recaptcha-container container">
            <p
              class="recaptcha-text"
              v-safe-html="config.pasos.consulta.recaptcha"
            ></p>
          </div>
        </wrap-container>
      </form-validator>
      <wrap-container
        class="recaptcha-holder w50"
        style="text-align: center; display: none;"
      >
        <vue-recaptcha
          ref="recaptcha"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
          @render="onCaptchaRendered"
          size="invisible"
          badge="inline"
          sitekey="6Lfp-yUUAAAAAFcXnw7yb4EhrGGz0zmF3SZhqViW"
        >
        </vue-recaptcha>
      </wrap-container>
    </wrap-container>
    <wrap-container
      class="relative-container cascade w50 consult-right column-1"
    >
      <img
        class="img-consulta"
        src="@/assets/img/ofertaNomina/banner-page-visit-ab.png"
        alt="Imagen escritorio"
      />
    </wrap-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { tiposDocumentos } from "@/config/constants";
import { get, getParameterByName } from "@/utils";
import WrapContainer from "@/components/core/Container";
import CountrySelector from "@/components/core/composite/combos/CountrySelector";
import FormValidator from "@/components/core/FormValidator";
import TextInput from "@/__tests-ab__/AR2024CNOMV2/components/core/TextInput";
import VueRecaptcha from "vue-recaptcha";
import EmailField from "@/__tests-ab__/AR2024CNOMV2/components/core/EmailField";
import DateField from "@/__tests-ab__/AR2024CNOMV2/components/core/DateField";
import CustomLink from "@/__tests-ab__/AR2024CNOMV2/components/core/CustomLink";
import SalesButton from "@/__tests-ab__/AR2024CNOMV2/components/core/SalesButton";
import DniInput from "@/__tests-ab__/AR2024CNOMV2/components/core/composite/DniInput";
import SectionLabel from "@/components/core/SectionLabel";
import ResidenceType from "@/components/core/custom/ResidenceType";
import PhoneNumber from "@/__tests-ab__/AR2024CNOMV2/components/core/composite/PhoneNumber";
import SexoSelect from "@/__tests-ab__/AR2024CNOMV2/components/core/custom/SexoSelect.vue";
import { RECHAZADO } from "@/config/constants/step-constants";
import * as ACTIONS from "@/config/constants/action-types";

export default {
  name: "Consulta",
  data() {
    return {
      paramsUrl: window.location.href.substring(
        window.location.href.indexOf("?")
      ),
      model: this.$store.getters.getConsulta(),
      recaptchaLoaded: false,
      isProduction: PRODUCTION,
      tiposDocumentos: tiposDocumentos
    };
  },
  computed: {
    ...mapState({
      /**
       * Forzar el DNI a DNE
       */
      forzarDNE: state => {
        return get(state, "forzarDNE.numeroDoc", false);
      }
    }),
    validarNumeroDocFechaNacimiento() {
      //Si el numero de doc es menor a 10 millones y nacio en 1955 o despues, es incompatible.
      if (this.model.numeroDoc < 10000000) {
        let fecha = this.model.fechaNacimiento.split("/");
        let fechaNacimiento = new Date(fecha[2], fecha[1], fecha[0]);

        let fechaReferencia = new Date(1954, 12, 31);
        if (fechaNacimiento > fechaReferencia) {
          return false; //No compatible
        }
      }
      return true;
    }
  },
  mounted() {
    this.$store.dispatch(ACTIONS.DO_IS_LOADING, false);
  },
  methods: {
    probar() {
      if (
        this.model.tipoResidencia === "temporal" &&
        this.model.tipoDoc == tiposDocumentos.DNE
      ) {
        this.$router.push({ name: "mensaje", params: { mje: RECHAZADO } });
        return;
      }

      this.$refs.recaptcha.execute();
    },
    async onCaptchaVerified(token) {
      this.$store.dispatch(ACTIONS.DO_IS_LOADING, true);
      this.$store.dispatch(ACTIONS.DO_INTERNAL_LINK, "conocer oferta");
      this.model.captcha = token;
      this.$store.dispatch(ACTIONS.DO_CONSULTA, this.model);
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    onCaptchaRendered() {
      /**
       * Recaptcha cargó correctamente
       */
      this.recaptchaLoaded = true;
    },
    trackClick(el) {
      /**
       * Hacer un dispatch del evento click sobre un elemento
       * para trackear analítica
       */
      this.$store.dispatch(ACTIONS.DO_CLICK_TRACKING, el);
    },
    showTerms() {
      /** Se dejan de mostrar los terminos y condiciones en un modal
       * con un archivo pdf, para mostrar los TYC del footer
       */
      document
        .getElementsByTagName("footer")[0]
        .scrollIntoView({ behavior: "smooth" });
    }
  },
  created() {
    //Busco parametro
    if (getParameterByName("hash")) {
      let hash = {
        hash: getParameterByName("hash")
      };
      this.$store.dispatch(ACTIONS.DO_CONSULTA, hash);
    }
  },
  components: {
    TextInput,
    EmailField,
    FormValidator,
    WrapContainer,
    DateField,
    CustomLink,
    SalesButton,
    DniInput,
    SectionLabel,
    ResidenceType,
    PhoneNumber,
    VueRecaptcha,
    CountrySelector,
    SexoSelect
  }
};
</script>
<style scoped>
.container-row {
  max-width: 1200px;
  margin: 0 auto;
}

.img-consulta {
  margin-top: 160px;
  width: 70%;
}

.terms-wrapper p {
  font-size: 15px;
  margin: 0 0 40px;
  line-height: 24px;
}

div.recaptcha-holder {
  margin-top: 24px;
  opacity: 0.3;
}

#subtitulo {
  margin-bottom: 40px;
  font-size: 16px;
}

#titulo {
  margin-bottom: 16px;
}

.double-width {
  margin-bottom: 32px;
}

.genero-sub {
  margin-top: -10px;
  margin-bottom: 25px;
}

.email-date {
  margin-bottom: 26px;
}

/* Rediseño */

.container-v2 {
  padding: 0 17px;
}

.flex-col-1 {
  display: flex;
  flex-direction: column;
  max-width: 100%;
}

.flex-col-1 .email-date {
  margin-bottom: 0;
}

.flex-col-1 .caret {
  display: block;
}

.consult-left.column-1 #titulo {
  font-size: 26px;
  font-weight: 700;
  line-height: 32px;
  max-width: 405px;
}

.consult-left.column-1 #subtitulo {
  font-size: 15px;
  line-height: 24px;
  margin-bottom: 40px;
  max-width: 500px;
}

.consult-left.column-1 {
  max-width: 500px;
}

.consult-right.column-1.mobile {
  display: none;
}

.consult-right.column-1 {
  text-align: right;
  max-width: 524px;
  margin-left: 142px;
  margin-bottom: 40px;
}

.terms-wrapper {
  max-width: 392px;
  margin-top: 16px;
}

.consult-right.column-1 .img-consulta {
  margin-top: -43px;
  width: 100%;
  max-width: 500px;
  max-height: 961px;
}

.recaptcha-container p {
  font-size: 12px;
  line-height: 24px;
  max-width: 435px;
  margin-top: 16px;
  margin-bottom: 40px;
}

.custom-container {
  gap: 24px;
}

.phone-container {
  flex-direction: row;
  gap: 32px;
  justify-content: space-between;
}

.phone-container > .col1 {
  width: 50%;
}

@media screen and (max-width: 1200px) {
  .consult-right.column-1 {
    margin-left: calc((100% / 2) - 440px);
  }
}

@media screen and (max-width: 1024px) {
  div.container {
    max-width: 100%;
  }

  .flex-col-1 {
    max-width: 100%;
  }

  .container-v2 {
    padding: 0;
  }

  .consult-right.column-1.mobile {
    display: block;
    margin: 0;
    width: 100%;
  }

  .consult-right.column-1.mobile img {
    display: block;
    margin-bottom: 40px;
  }

  .consult-left.column-1 {
    max-width: 100%;
    padding: 0 16px;
  }

  .consult-right {
    display: none;
  }

  .consult-left {
    width: 100%;
    margin: 0 auto;
    max-width: 1200px;
  }

  .img-consulta {
    display: none;
  }

  .consult-right.column-1 .img-consulta {
    max-width: 100%;
  }

  .consult-right.column-1 {
    max-width: 100%;
  }

  .consult-left.column-1 #titulo {
    max-width: 280px;
  }

  .consult-left.column-1 #subtitulo {
    margin-bottom: 32px;
  }
}

@media screen and (max-width: 624px) {
  #titulo {
    font-size: 20px;
  }

  #subtitulo {
    font-size: 18px;
  }

  .grid-container {
    margin-bottom: 24px;
  }

  .terms-wrapper p {
    line-height: 24px;
    margin-top: 0;
    text-align: left;
  }
}
</style>
